<template>
  <div class="">
    <div class="m-background m-background--media-1"></div>
    <div class="m-background__overlay m-background__overlay--yellow"></div>
    <div class="l-container u-text--center">
      <Rank  class="m-rank--medium"/>
      <h2 class="m-game-over-win__title">Congratulations!</h2>
      <h4 class="m-game-over-win__body">You've completed all challenges</h4>
      <div class="columns">
        <div class="column"></div>
        <div class="column">
          <h4 class="m-game-over-win__result-type">Final Budget:</h4>
          <h5 class="m-game-over-win__result m-game-over-win__result--budget">
            {{ getBudget | currency }}
          </h5>
        </div>
        <div class="column">
          <h4 class="m-game-over-win__result-type">Final Score:</h4>
          <h5 class="m-game-over-win__result m-game-over-win__result--score">
            {{ getScore }}/48
          </h5>
        </div>
        <div class="column"></div>
      </div>
      <div class="m-game-over-win__actions">
          <router-link class="m-btn m-btn--left m-btn__primary"
          :to="{ name: 'explore-careers' }">Explore Careers</router-link>
        <router-link class="m-btn m-btn--left m-btn__primary"
          :to="{ name: 'home' }">Play Again</router-link>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Rank from '../components/header/Rank';

export default {
  created() {
    this.storeResponsesInFirebase();
  },
  components: {
    Rank,
  },
  computed: {
    ...mapGetters(['getScore', 'getBudget']),
  },
  methods: {
    ...mapActions(['storeResponsesInFirebase']),
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/GameOverWin.vue